// US help / User-Manual route map.
//
//   /help              overview + table of contents (index)
//   /help/:sectionId   one manual section (getting-started, quotes, …)
//
// Nested under a shared HelpLayout so the left table-of-contents persists while
// the section content swaps via <Outlet/>. Lazy-loaded to match the other
// module route maps.

import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HelpLayout = lazy(() =>
  import('./components/HelpLayout').then((m) => ({ default: m.HelpLayout })),
);
const HelpOverviewPage = lazy(() =>
  import('./pages/HelpOverviewPage').then((m) => ({ default: m.HelpOverviewPage })),
);
const HelpSectionPage = lazy(() =>
  import('./pages/HelpSectionPage').then((m) => ({ default: m.HelpSectionPage })),
);

export const helpRoutes: RouteObject[] = [
  {
    path: '/help',
    element: <HelpLayout />,
    children: [
      { index: true, element: <HelpOverviewPage /> },
      { path: ':sectionId', element: <HelpSectionPage /> },
    ],
  },
];
